<template>
  <div>
    <div class="appointmens-item">
      <Row type="flex" align="middle" class="appointmens-item__header">
        <Col>
          <Row type="flex" align="middle" :gutter="30">
            <Col> <h3 class="is-title">Ваши заявки</h3></Col>
            <Col>
              <v-tag
                rounded
                color="gray"
                :text="`${actualAppointments.length}`"
              />
            </Col>
          </Row>
        </Col>
      </Row>
      <div class="list">
        <ListHeader align="middle" type="appointments" />
        <UserCard
          type="appointments"
          v-for="(item, index) in actualAppointments"
          :key="index"
          :data="item"
        />
      </div>
    </div>

    <div
      v-if="showArchive"
      class="appointmens-item appointmens-item--archived"
    >
      <Row type="flex" align="middle" class="appointmens-item__header">
        <Col>
          <Row type="flex" align="middle" :gutter="30">
            <Col><h3 class="is-title text--gray">Архив заявок</h3> </Col>
            <Col>
              <v-tag
                rounded
                color="gray"
                :text="`${archivedAppointments.length}`"
              />
            </Col>
          </Row>
        </Col>
      </Row>
      <div class="list">
        <list-header align="middle" type="appointments" />
        <user-card
          type="appointments"
          v-for="(item, index) in archivedAppointments"
          :key="index"
          :data="item"
        />
      </div>
    </div>
  </div>
</template>

<script>
import appointmentsMixin from "../mixins/appointmentsMixin";


export default {
  name: "AppointmentsClient",


  mixins: [
    appointmentsMixin,
  ],


  data() {
    return {
      showArchive: false,
    };
  },


  computed: {
    actualAppointments() {
      return this.getAppointmentsByArchivedState(false);
    },

    archivedAppointments() {
      return this.getAppointmentsByArchivedState(true);
    }
  },


  methods: {
    /**
     * TODO: how do we archive appointments now?
     */
    getAppointmentsByArchivedState(state) {
      return this.appointments
        .filter(el => el.is_archived === state)
        .sort((a, b) => b.datetime - a.datetime);
    }
  },
};
</script>
